import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'azavista3-edit-mode-buttons',
    template: `
        @if (editMode) {
          <div class="buttons-row aza-pa-flex-row" [class.aza-pa-flex-item-content-end]="justifyButtonsToTheRight">
            <azavista-flat-button action="cancel" (click)="onCancelClick()" color="primary" class="cancel-button">
              <span>{{'CANCEL' | translate | uppercase}}</span>
            </azavista-flat-button>
            <azavista-button action="save" [disabled]="saveDisabled" (click)="onSaveClick()" color="primary" class="apply-button">
              <span>{{'SAVE' | translate | uppercase}}</span>
            </azavista-button>
          </div>
        }
        `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EditModeButtonsComponent {
    @Input() editMode: boolean;
    @Input() justifyButtonsToTheRight = false;
    @Input() saveDisabled = false;
    @Output() save = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    onCancelClick(): void {
        this.cancel.emit();
    }

    onSaveClick(): void {
        this.save.emit();
    }

}
